import React, { useEffect, useRef, useState } from 'react'
import { ListScreen } from '../../components'
import { GridColumn } from '@progress/kendo-react-grid'
import { Dialog } from "@progress/kendo-react-dialogs";
import { useTranslation } from 'react-i18next';
import ColorDetail from './ColorDetail';

const Tab1 = ({ productid }) => {
    const [show, setShowstate] = useState({ show: false, data: {} })
    const [userSendData, setUserSenddata] = useState({ productid })

    const { t } = useTranslation()
    const gridRef = useRef(null);


    const refreshData = () => {
        if (gridRef.current) {
            gridRef.current.readData()
        }
    }

    const createFunction = () => {
        setShowstate({ show: true, data: {} })
    }

    const detailFuncion = (data) => {
        setShowstate({ show: true, data })
    }

    const onClose = () => {
        setShowstate({ show: false, data: {} });
        refreshData()
    }

    const colorCell = ({ dataItem }) => {
        return <td>
            <div className='rounded-full size-4'
                title={dataItem.color}
                style={{
                    backgroundColor: dataItem.color
                }}></div>
        </td>
    }

    useEffect(() => {
        setUserSenddata({ productid })
    }, [productid])

    return (
        <div>
            <ListScreen
                read={'ml000016'}
                delete={'ml000020'}
                customFunction={createFunction}
                detailFuncion={detailFuncion}
                createable={false}
                customFunctionText={t('create')}
                userSendData={userSendData}
                ref={gridRef}
            >
                <GridColumn field='color' title={t('color')} filter='text' cell={colorCell}/>
                <GridColumn field='name' title={t('name')} filter='text' />
            </ListScreen>
            {show.show &&
                <Dialog
                    width={'80vw'}
                    height={'auto'}
                    title={t('detail')}
                    onClose={() => {
                        setShowstate({
                            show: false, data: {}
                        });
                        refreshData()
                    }}
                    className="px-0 pt-0"
                >
                    <ColorDetail show={show} productid={productid} onClose={onClose} />
                </Dialog>
            }
        </div>
    )
}

export default Tab1